import { Toaster } from 'sonner';

/**
 * Toaster Sonner do help-center público (avisos gerais).
 * A lista de desejos Fairtrade usa `FairtradeWishlistToastHost` (empilhamento MSN).
 */
export function PublicToaster() {
  return (
    <Toaster
      theme="dark"
      position="bottom-right"
      gap={10}
      offset={24}
      visibleToasts={3}
      expand={false}
      toastOptions={{
        classNames: {
          toast:
            'rounded-2xl border border-rose-400/40 bg-gradient-to-br from-[#2a0a18]/96 via-[#1a0610]/96 to-[#0c0408]/96 ' +
            'font-inter text-rose-50 shadow-[0_12px_40px_-12px_rgba(190,24,93,0.45)] backdrop-blur-xl',
          title: 'font-poppins text-sm font-semibold tracking-tight text-rose-50',
          description: 'font-inter text-[13px] text-rose-200/70',
        },
      }}
    />
  );
}
